import { useEffect, useState } from 'react';
import Link from './link.js';
import { t } from '../common/i18n.js';

function Header({ locale }) {
  const [theme, setTheme] = useState('light');
  const storageKey = 'uptime-theme';

  const applyTheme = (nextTheme) => {
    document.body.classList.remove('theme-light', 'theme-dark');
    document.body.classList.add(`theme-${nextTheme}`);
  };

  useEffect(() => {
    document.title = window.Config.SiteName;

    const saved = localStorage.getItem(storageKey);
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const initialTheme = saved === 'dark' || saved === 'light' ? saved : (prefersDark ? 'dark' : 'light');
    setTheme(initialTheme);
    applyTheme(initialTheme);

    const media = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    if (!media) return;
    const handleChange = (event) => {
      const persisted = localStorage.getItem(storageKey);
      if (persisted === 'dark' || persisted === 'light') return;
      const nextTheme = event.matches ? 'dark' : 'light';
      setTheme(nextTheme);
      applyTheme(nextTheme);
    };

    if (media.addEventListener) {
      media.addEventListener('change', handleChange);
    } else if (media.addListener) {
      media.addListener(handleChange);
    }

    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', handleChange);
      } else if (media.removeListener) {
        media.removeListener(handleChange);
      }
    };
  }, []);

  const toggleTheme = () => {
    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(nextTheme);
    localStorage.setItem(storageKey, nextTheme);
    applyTheme(nextTheme);
  };

  return (
    <div id='header'>
      <div className='container'>
        <h1 className='logo'>{window.Config.SiteName}</h1>
        <div className='navi'>
          {window.Config.Navi.map((item, index) => (
            <Link key={index} to={item.url} text={item.text} />
          ))}
          <button
            className='theme-toggle'
            type='button'
            aria-label={t(locale, 'themeToggleAria')}
            aria-pressed={theme === 'dark'}
            onClick={toggleTheme}
          >
            <span className='theme-toggle__icon' aria-hidden='true'>
              {theme === 'dark' ? '🌙' : '☀️'}
            </span>
            <span className='theme-toggle__text'>
              {theme === 'dark' ? t(locale, 'themeDark') : t(locale, 'themeLight')}
            </span>
            <span className='theme-toggle__track' aria-hidden='true'>
              <span className='theme-toggle__thumb' />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
